import { backgroundImageForUrl } from '@shared/utils/style/backgroundImage';
import React from 'react';
import { addRendition } from '@shared/utils/photoRendition';
import { Box } from '@withjoy/joykit';
import { WebsitePhotoAlignment, WebsitePhotoBaseProperties } from '@apps/guest/websiteHeader';

export const Photo: React.FC<Partial<WebsitePhotoBaseProperties> & { alignment?: WebsitePhotoAlignment; showPlaceholder?: boolean }> = props => {
  const { url, alignment, showPlaceholder } = props;

  return (
    <>
      <Box
        style={{
          height: '100vh',
          backgroundImage: backgroundImageForUrl(addRendition({ url, renditionSize: 'xlarge' })),
          backgroundSize: 'cover',
          backgroundPosition: `${alignment?.alignX} ${alignment?.alignY}`,
          backgroundRepeat: 'no-repeat',
          ...(showPlaceholder &&
            !url && {
              backgroundColor: 'lightgray',
            }),
        }}
      />
    </>
  );
};
